import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'ard-waiting-dialog',
	templateUrl: './waiting-dialog.component.html'
})
export class WaitingDialogComponent {
	constructor(
		public dialogRef: MatDialogRef<WaitingDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { }

	ngOnInit() {
		setTimeout(() => {
			this.dialogRef.close(true);
		}, 2500);
	}

	onNoClick(): void {
		this.dialogRef.close();
	}
}
